import { HelperContext } from "../../Helper/helper.context";

import ImgHelpWaterlevelBazis from '../../../images/help_context/water_level_bazis.png';

export const WaterlevelHelpContext = ({onClose}) => {
    return (
        <HelperContext 
        onClose={onClose}
        children={
            <div style={{position: "relative", flexGrow: 1}}>
                <div className="text-center">
                    <img src={ImgHelpWaterlevelBazis} alt=""/>
                </div>
            </div>
        }
    />    
)}